export const anchor = {
  anchor: {
    gutter: '0',
  },
};
